import http from '@/api/base'

// 测试接口
const testOne = () => {
  return http.get('/dcits-consumption/test/testOne')
}

// 查询所有企业开票信息
const queryInvEnterprise = (params, current, size) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return http.post('/invEnterprise/v2/queryInvEnterprise?current=' + current + '&size=' + size, params)
  } else {
    return http.post('/dcits-consumption/invEnterprise/v2/queryInvEnterprise?current=' + current + '&size=' + size, params)
  }
}
// 添加企业开票信息
const addInvEnterpriseIssuance = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return http.post('/invEnterprise/v2/addInvEnterpriseIssuance', params)
  } else {
    return http.post('/dcits-consumption/invEnterprise/v2/addInvEnterpriseIssuance', params)
  }
}

//* ************************************************************************************* */
// ****注意：上面的接口与下面的接口路径一致，但是版本号不一致，功能也不一致，写在一起只是为了方便区分
// 修改开票信息
const modifyInvEnterpriseIssuance = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return http.post('/invEnterprise/v2/modifyInvEnterpriseIssuance', params)
  } else {
    return http.post('/dcits-consumption/invEnterprise/v2/modifyInvEnterpriseIssuance', params)
  }
}
// 数电补录修改接口
// ****注意：上面的接口与下面的接口路径一致，但是版本号不一致，功能也不一致，写在一起只是为了方便区分
const modifyInvDigitalCircuit = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return http.post('/invEnterprise/modifyInvEnterpriseIssuance', params)
  } else {
    return http.post('/dcits-consumption/invEnterprise/modifyInvEnterpriseIssuance', params)
  }
}
//* ************************************************************************************* */

// 根据企业id查询所有开票信息
const batchSelectInvEnterpriseIssuance = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return http.post('/invEnterprise/v2/batchSelectInvEnterpriseIssuance?enterpriseId=' + params.enterpriseId, params)
  } else {
    return http.post('/dcits-consumption/invEnterprise/v2/batchSelectInvEnterpriseIssuance?enterpriseId=' + params.enterpriseId, params)
  }
}
// 获取企业详情
const delInvEnterpriseIssuance = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return http.post('/invEnterprise/v2/delInvEnterpriseIssuance?id=' + params.id, params)
  } else {
    return http.post('/dcits-consumption/invEnterprise/v2/delInvEnterpriseIssuance?id=' + params.id, params)
  }
}

export default {
  testOne,
  queryInvEnterprise,
  delInvEnterpriseIssuance,
  addInvEnterpriseIssuance,
  batchSelectInvEnterpriseIssuance,
  modifyInvEnterpriseIssuance,
  modifyInvDigitalCircuit
}



// WEBPACK FOOTER //
// ./src/area-dcits/api/invoicestration.js